import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModalDefault from '@/components/modal/default';
import SpinnerInlerno from '@/components/spinners/inlearno';
import { ComponentProps, EventsEnum } from './types';

const { CHANGE, COMPLETED, FAIL } = EventsEnum;

@Component({
  components: {
    ModalDefault,
    SpinnerInlerno,
  },
  model: {
    prop: 'process',
    event: 'change',
  },
})
export default class ComponentIntalentTest extends Vue
  implements ComponentProps {
  // Props
  @Prop({ type: String, default: 'Пройти тест' })
  buttonText: string;

  @Prop({ type: String, default: 'fail' })
  fail: string;

  @Prop({ type: String, required: true })
  iframeSrc: string;

  @Prop({ type: Boolean, required: false })
  process: boolean;

  @Prop({ type: String, default: 'success' })
  success: string;

  // Data
  wait = true;

  // Watch
  @Watch('process')
  onProcessChange(value: boolean) {
    if (!value) this.wait = true;
  }

  // Hooks
  mounted() {
    window.addEventListener('message', this.onMessage);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  }

  // Methods
  change() {
    this.$emit(CHANGE, !this.process);
  }

  onClick() {
    this.change();
  }

  onClose() {
    this.change();
  }

  onMessage({ data, source }: MessageEvent) {
    const { fail, success } = this;
    switch (data) {
      case success:
      case 'finishTestGame':
      case 'closeAtlasFrame':
        this.$emit(COMPLETED);
        break;
      case fail:
        this.$emit(FAIL);
        break;
    }
  }

  onLoad() {
    this.wait = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/intalent/test/script.ts